import type { ResponsiveDialogProps } from '@/shared/components/ui/custom/responsive-dialog';
import { ResponsiveDialog } from '@/shared/components/ui/custom/responsive-dialog';

export function DownloadModalRoot(props: ResponsiveDialogProps) {
  return <ResponsiveDialog {...props} />;
}
